(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelectorAll('.tab-button').length > 0){
      const tabs = document.querySelectorAll('.tab-button');
      tabs.forEach(tab => {
            tab.addEventListener('click', function() {
                tabs.forEach(t => {
                    t.classList.remove('active');
                });
                this.classList.add('active');
                const section = document.querySelector(tab.getAttribute('data-href'));
                if (section){
                  let scrollDiv = section.offsetTop - 150;
                  window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                } 
            });
      });
    } 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-embed"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.peep-shoppable-video__sound_buttons').forEach(function(elem){
      elem.onclick = function(event){
        event.preventDefault();
        let card = elem.closest('.peep-shoppable-video__card');
        let cardParent = card.closest('.peep-shoppable-video');
        let videoElement = card.getElementsByTagName('video')[0];
        if(card.classList.contains('sound-on')){
            videoElement.muted = true;
        }
        else{
            if(cardParent.querySelector('.peep-shoppable-video__card.sound-on')){
                cardParent.querySelector('.peep-shoppable-video__card.sound-on').querySelector('video').muted = true;
                cardParent.querySelector('.peep-shoppable-video__card.sound-on').classList.remove('sound-on');
            }
            videoElement.muted = false;
        }
        elem.closest('.peep-shoppable-video__card').classList.toggle('sound-on');
      }
  });

  } catch(e) { console.error(e); }
})();
})();
